import router from "./router";
import store from "./store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import Layout from './layout/index.vue'
import { getToken } from "@/utils/auth";
NProgress.configure({ showSpinner: false });
const whiteList = [
  "/login",
  "/redirect",
  "/404",
  "/401"
];
const h5List = [
  "/qwH5/fankui",
  "/qwH5/malfunction"
];
/**
 * 转换路由数据为组件
 */
const loadView = (view) => {
  return () => import("@/views/" + view);
};
const transformRoutes = (routes) => {
  const asyncRoutes= [];
  routes.forEach((route) => {
    const tmpRoute = { ...route };
    // 顶级目录，替换为 Layout 组件
    console.log(tmpRoute,'==tmpRoute')
    if (tmpRoute.component?.toString() == "Layout") {
      tmpRoute.component = Layout;
    } else {
      // 其他菜单，根据组件路径动态加载组件
      const component =loadView(tmpRoute.component) 
      if (component) {
        tmpRoute.component = component;
      } else {
        tmpRoute.component =loadView('error/404')
      }
    }
    if (tmpRoute.children) {
      tmpRoute.children = transformRoutes(route.children);
    }
    
    asyncRoutes.push(tmpRoute);
  });

  return asyncRoutes;
};
router.beforeEach(async (to, from, next) => {
  if (h5List.indexOf(to.path) == -1) {
    // 非企微h5端页面直接进入
 
  NProgress.start();

  if (getToken()) {
    /* has token*/
    if (to.path === "/login") {
      next({ path: "/" });
      NProgress.done();
    } else {
      if (to.path === "/" && store.state.common.userInfo && store.state.common.userInfo.userType !== undefined) {
        const home = store.state.common.userInfo.userType == 3 ? "/homePlatform" : "/homeTenant";
        next({ path: home, replace: true });
        NProgress.done();
        return;
      }
      if (to.path === "/@/views/login") {
        next(`/login`);
      }
      if (store.state.common.roles.length === 0) {
        const res = await store.dispatch("common/GetInfo");
        const accessRoutes = await store.dispatch("common/getMenu");
        console.log(accessRoutes,'accessRoutes---')
        // 判断当前用户是否已拉取完user_info信息
        // store
        //   .dispatch("GetInfo")
        //   .then(res => {
        //     // 拉取user_info
        //     const roles = res.roles;
        //     store.dispatch("GenerateRoutes", { roles }).then(accessRoutes => {
        //       // 根据roles权限生成可访问的路由表
              let route = transformRoutes(accessRoutes)
              console.log(route,'route')
              route.forEach((item) => { // 动态添加可访问路由表
                router.addRoute(item);
              });


              // next();


              // if((to.query.currentName&&to.query.currentDept)||to.query.isAdmin){
              //   if(to.query.isAdmin){
              //     sessionStorage.setItem('currentName','');
              //     sessionStorage.setItem('currentDept','');
              //     sessionStorage.setItem('isAdmin',1);

              //   }else{
              //     sessionStorage.setItem('currentName',1);
              //     sessionStorage.setItem('currentDept',54401);
              //   }
              //   next()
              // }else{
              //   if((sessionStorage.getItem('currentName')&&sessionStorage.getItem('currentDept'))||sessionStorage.getItem('isAdmin')){
              //     next();
              //   }else{
              //     next(false)
              //   }
              // }
              // next();
              next({ ...to, replace: true }); // hack方法 确保addRoutes已完成
        //     });
        //   })
        //   .catch(err => {
        //     store.dispatch("FedLogOut").then(() => {
        //       Message.error(err);
        //       next({ path: "/" });
        //     });
        //   });
      } else {
        next();
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
        // if (hasPermission(store.getters.roles, to.meta.roles)) {
        //   next()
        // } else {
        //   next({ path: '/401', replace: true, query: { noGoBack: true }})
        // }
        // 可删 ↑
      }

    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
      NProgress.done();
    } else {
      // 去登录页
      next(`/login?redirect=${to.path}`); // 否则全部重定向到登录页
      NProgress.done();
    }
  }
}else{
  next()
}
});

router.afterEach(() => {
  NProgress.done();
});

